/**
 * 图表
 */

import request from '@/utils/request'

// 会议趋势 一级管理员
export function meetingTendency(data) {
    return request({
        url: '/buis/meeting/hero/meetingTendency',
        method: 'get',
        params: {
            enterpriseId: data.enterpriseId,
            beginTime: data.beginTime,
            endTime: data.endTime,
            identification: data.identification
        }
    })
}






//数量查询
export function userCount(pfid, schoolId) {
    return request({
        url: `/user/edu/user/userCount?pfid=${pfid}&schoolId=${schoolId}`,
        method: 'get',

    })
}
//设备数量查询
export function getEquipmentCondition(schoolId) {
    return request({
        url: `/edu/equipment/getEquipmentCondition?schoolId=${schoolId}`,
        method: 'post',

    })
}

//超管查询用户登录趋势(教育平台)
export function userLoginTendency(data) {
    return request({
        url: `/user/edu/user/userLoginTendency`,
        method: 'post',
        data: data
    })
}

//学校管理员学校班级数量(教育平台)
export function classDistribution(schoolId) {
    return request({
        url: `/user/edu/user/classDistribution?schoolId=${schoolId}`,
        method: 'post',

    })
}

//学校管理员查看教师分布(教育平台)
export function teacherDistribution(schoolId) {
    return request({
        url: `/basic/baseEduSubject/user/teacherDistribution?schoolId=${schoolId}`,
        method: 'post',

    })
}

//学校管理员学校班级数量(教育平台)
export function getSchoolCount() {
    return request({
        url: `/basic/baseEduSchool/getSchoolCount`,
        method: 'post',

    })
}





//管理员查看设备的使用趋势(教育平台)

export function getEquipmentTendency(data) {
    return request({
        url: `/edu/equipment/getEquipmentTendency`,
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/echarts.js